import { __rest } from '../../../node_modules/tslib/tslib.es6.js';
import { styled } from '@mui/material/styles';
import React from 'react';
import brandclub_colors from '../../../colors/brandclubColors.js';
import '../../../Components/Button/BackButton.js';
import { Button } from '../../../Components/Button/Button.js';
import '../../../Components/Button/CloseButton.js';
import '../../../Components/Button/CustomDtcBagButton.js';
import '../../../icons/abstract/AbstractArcIcon.js';
import '../../../icons/AddCircleIcon.js';
import '../../../icons/AddCircleOutlineIcon.js';
import '../../../icons/ArrowCircleRightIcon.js';
import '../../../icons/ArrowLeftIcon.js';
import { ArrowRightIcon } from '../../../icons/ArrowRightIcon.js';
import '../../../icons/BoltIcon.js';
import '../../../icons/BookmarkStarIcon.js';
import '../../../icons/CalendarIcon.js';
import '../../../icons/CancelIcon.js';
import '../../../icons/ChatIcon.js';
import '../../../icons/CheckCircleIcon.js';
import '../../../icons/ChevronDownIcon.js';
import '../../../icons/ChevronLeftIcon.js';
import '../../../icons/ChevronRightIcon.js';
import '../../../icons/ChevronUpIcon.js';
import '../../../icons/CloseIcon.js';
import '../../../icons/MenuIcon.js';
import '../../../icons/NotificationActiveIcon.js';
import '../../../icons/PaperPlaneIcon.js';
import '../../../icons/PendingIcon.js';
import '../../../icons/PersonIcon.js';
import '../../../icons/PlayCircleIcon.js';
import '../../../icons/RemoveCircleIcon.js';
import '../../../icons/SearchIcon.js';
import '../../../icons/SellIcon.js';
import '../../../icons/ShoppingBagIcon.js';
import '../../../icons/SmartphoneIcon.js';
import '../../../icons/StarIcon.js';
import '../../../icons/StarOutlineIcon.js';
import { SuccessCheckCircleIcon } from '../../../icons/SuccessCheckCircleIcon.js';
import '../../../icons/TuneIcon.js';
import '../../../icons/FourPointStarIcon.js';
import '../../../analytics/events.js';
import 'uuid';
import 'lodash/includes';
import '../../../types/filters.js';
import '../../../utils/assetUtils.js';
import '../../../utils/brandclubStoreConfigUtils.js';
import 'numeral';
import { escapeUriPath, formatMoney } from '../../../utils/stringUtils.js';
import '../../../utils/broadcast.js';
import { MOBILE_SCREEN_SIZE } from '../../../utils/constants/Constants.js';
import 'awesome-phonenumber';
import 'lodash/isEqual';
import 'lodash/get';
import 'lodash/orderBy';
import '../../../types/Campaign.js';
import '../../../types/product.js';
import '../../../api/graphQl/brand.js';
import '../../../api/graphQl/product.js';
import '@brandclub/types';
import '../../../utils/logger.js';
import { ButtonLoadingEllipsis } from '../Loading/index.js';

var BrandCardContainer = styled('div')(function () {
    var _a;
    return (_a = {
            border: 'solid 1px #dcdddc',
            width: '100%',
            height: '100%',
            borderRadius: 12,
            // matches product card padding
            padding: '16px 16px 16px 22px',
            paddingTop: 58,
            cursor: 'pointer',
            boxSizing: 'border-box',
            transition: 'background-color 0.4s ease-in-out',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 0
        },
        _a["@media (max-width: ".concat(MOBILE_SCREEN_SIZE, "px)")] = {
            padding: 10,
            paddingTop: 52,
            width: '100%',
        },
        _a);
});
var BrandLogoContainer = styled('div')(function () { return ({
    width: 'calc(100% - 24px)',
    maxWidth: '190px',
    aspectRatio: '1/1',
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
}); });
var BrandLogoImg = styled('img')(function (_a) {
    var theme = _a.theme;
    return ({
        width: '100%',
        maxWidth: 149,
        aspectRatio: '1/1',
        backgroundColor: theme.palette.common.white,
        objectFit: 'contain',
        borderRadius: 999,
    });
});
var BrandName = styled('h2')(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            fontSize: 22,
            fontWeight: 600,
            marginBottom: 16.7,
            marginTop: 20,
            color: theme.palette.primary.main,
            overflow: 'hidden',
            width: '80%',
            textAlign: 'center',
            textDecoration: 'none',
            letterSpacing: 0.36,
            WebkitLineClamp: 1,
            lineHeight: 1.5,
            height: "1.5em",
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            wordBreak: 'break-word'
        },
        _b["@media (max-width: ".concat(MOBILE_SCREEN_SIZE, "px)")] = {
            fontSize: 16,
        },
        _b);
});
var BrandCardStatusMessage = styled('div')(function (_a) {
    var _b, _c;
    var theme = _a.theme;
    return (_b = {
            fontSize: 16,
            fontWeight: 600,
            marginTop: 29.3,
            color: theme.palette.primary.main,
            display: 'flex',
            alignItems: 'center',
            textAlign: 'center'
        },
        _b["@media (max-width: ".concat(MOBILE_SCREEN_SIZE, "px)")] = {
            fontSize: 12,
        },
        _b['.arrow'] = (_c = {
                width: 13,
                height: 13,
                objectFit: 'contain',
                marginLeft: 10
            },
            _c["@media (max-width: ".concat(MOBILE_SCREEN_SIZE, "px)")] = {
                width: 10,
                height: 10,
            },
            _c),
        _b);
});
var BrandCardButton = styled(Button)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            backgroundColor: brandclub_colors.white,
            color: theme.palette.primary.main,
            border: "1.5px solid ".concat(theme.palette.primary.main),
            height: 40,
            fontSize: 17,
            fontWeight: 600,
            minWidth: 108
        },
        _b["@media (max-width: ".concat(MOBILE_SCREEN_SIZE, "px)")] = {
            height: 30,
            fontSize: 12,
            minWidth: 88,
        },
        _b);
});
var BrandCardButtonSolid = styled(BrandCardButton)(function () { return ({
    backgroundColor: brandclub_colors.grayF3F4F5,
    border: "1.5px solid ".concat(brandclub_colors.grayF3F4F5),
}); });
var getBrandActivityPath = function (brand) {
    return "/".concat(escapeUriPath(brand.name), "/b/").concat(brand.brandId, "/branddashboard/rewards/activity");
};
var getBrandHomePath = function (brand) { return "/".concat(escapeUriPath(brand.name), "/b/").concat(brand.brandId, "/home"); };
var BrandCardJoinButton = function (props) {
    var _a, _b;
    if (props.joined) {
        return React.createElement(BrandCardButton, null, formatMoney((_b = (_a = props.brand) === null || _a === void 0 ? void 0 : _a.rewardAmount) !== null && _b !== void 0 ? _b : 0));
    }
    if (props.joinedState === 'not_join') {
        return React.createElement(BrandCardButtonSolid, { onClick: props.onJoin }, "Join");
    }
    if (props.joinedState === 'joining') {
        return (React.createElement(BrandCardButtonSolid, null,
            "Joining",
            React.createElement(ButtonLoadingEllipsis, { baseFontSize: 17, blue: true })));
    }
    return (React.createElement(BrandCardButton, null,
        React.createElement(SuccessCheckCircleIcon, { className: "button_img" }),
        "Member"));
};
var BrandCardJoinMessage = function (props) {
    var brand = props.brand, LinkComponent = props.LinkComponent;
    var viewActivityPath = getBrandActivityPath(brand);
    var homePath = getBrandHomePath(brand);
    if (props.joinedState === 'joined' && props.reward) {
        return (React.createElement(BrandCardStatusMessage, null, "You earned ".concat(formatMoney(props.reward), " by joining this club")));
    }
    return (React.createElement(LinkComponent, { to: props.joined ? viewActivityPath : homePath, style: {
            textDecoration: 'none',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
        } },
        React.createElement(BrandCardStatusMessage, null,
            React.createElement("span", null, props.joined ? 'View activity' : "Visit ".concat(brand.name)),
            React.createElement(ArrowRightIcon, { className: "arrow", color: "primary" }))));
};
var ProductBrandCard = function (_a) {
    var brand = _a.brand, joined = _a.joined, joinedState = _a.joinedState, reward = _a.reward, LinkComponent = _a.LinkComponent, props = __rest(_a, ["brand", "joined", "joinedState", "reward", "LinkComponent"]);
    return (React.createElement(BrandCardContainer, null,
        React.createElement(LinkComponent, { to: getBrandHomePath(brand), style: {
                textDecoration: 'none',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
            } },
            React.createElement(BrandLogoContainer, null,
                React.createElement(BrandLogoImg, { alt: "logo", src: brand.imageUrl })),
            React.createElement(BrandName, null, brand.name),
            React.createElement(BrandCardJoinButton, { brand: brand, joined: joined, onJoin: props.onJoin, joinedState: joinedState })),
        React.createElement(BrandCardJoinMessage, { joinedState: joinedState, reward: reward, joined: joined, brand: brand, LinkComponent: LinkComponent })));
};

export { ProductBrandCard as default };
//# sourceMappingURL=ProductBrandCard.js.map
